module.exports = __webpack_public_path__ + "account/assets/vk.284fb14e.svg";